/*智慧导览-子路由*/
export default [
  {
    path: '/tour/online',
    name: 'online',
    redirect: '/tour/online/exroom',
    component: resolve => require(['@/components/tour/online/index.vue'], resolve),
    meta: {
      title: '语音导览'
    },
    children: [
      {
        path: '/tour/online/exroom',
        name: 'online_exroom',
        component: resolve => require(['@/components/tour/online/exroom.vue'], resolve),
        meta: {
          title: '语音导览'
        }
      },
      {
        path: '/tour/online/list/:exhibition_id',
        name: 'online_list',
        component: resolve => require(['@/components/tour/online/list.vue'], resolve),
        meta: {
          title: '语音导览'
        }
      },
      {
        path: '/tour/online/detail/:exhibition_id/:exhibit_id',
        name: 'online_detail',
        component: resolve => require(['@/components/tour/online/detail.vue'], resolve),
        meta: {
          title: '展品详情'
        }
      },
      {
        path: '/tour/online/search/:keyword',
        name: 'online_search',
        component: resolve => require(['@/components/tour/online/search.vue'], resolve),
        meta: {
          title: '展品搜索'
        }
      }
    ]
  },
  {
    path: '/tour/commodity',
    name: 'commodity',
    redirect: '/tour/commodity/list',
    component: resolve => require(['@/components/tour/commodity/index.vue'], resolve),
    meta: {
      title: '文创产品'
    },
    children: [
      {
        path: '/tour/commodity/list',
        name: 'list',
        component: resolve => require(['@/components/tour/commodity/list.vue'], resolve),
        meta: {
          title: '文创产品'
        }
      },
      {
        path: '/tour/commodity/detail/:id',
        name: 'detail',
        component: resolve => require(['@/components/tour/commodity/detail.vue'], resolve),
        meta: {
          title: '文创详情'
        }
      }
    ]
  },
  {
    path: '/tour/hbjz',
    name: 'hbjz',
    redirect: '/tour/hbjz/list',
    component: resolve => require(['@/components/tour/hbjz/index.vue'], resolve),
    meta: {
      title: '河博集珍'
    },
    children: [
      {
        path: '/tour/hbjz/list',
        name: 'list',
        component: resolve => require(['@/components/tour/hbjz/list.vue'], resolve),
        meta: {
          title: '河博集珍'
        }
      },
      {
        path: '/tour/hbjz/detail/:id',
        name: 'detail',
        component: resolve => require(['@/components/tour/hbjz/detail.vue'], resolve),
        meta: {
          title: '集珍详情'
        }
      }
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/tour/index.js